import { useTranslation } from 'react-i18next';
import { DevelService } from '../../services';
import LanguageSwitcher from '../../components/i18n/LanguageSwitcher';

const PlatformBadge = () => {
  const { t } = useTranslation();

  if (DevelService.isProduction()) {
    return;
  }

  return (
    <div className="platform-badge-ctr">
      <div className="platform-badge">
        {import.meta.env.REACT_APP_PLATFORM_BADGE ||
          import.meta.env.REACT_APP_ENV_VALUE ||
          import.meta.env.MODE ||
          `[${t('common.unknown')}]`}
      </div>
      <LanguageSwitcher context="platform-badge" />
    </div>
  );
};

export default PlatformBadge;
